<template>
  <div class="gf-collapse">
    <div
      class="gf-collapse__toggle"
      :class="[{ '--hide': isHidedToggle }, toggleClass]"
      @click="click"
    >
      <slot name="toggle" />
    </div>
    <div
      class="gf-collapse__collapse"
      :class="{ '--show': isOpen }"
    >
      <slot name="collapse" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GfCustomCollapse',
  props: {
    defaultOpen: {
      type: Boolean,
      default: false
    },
    isHidedToggleAfterOpening: {
      type: Boolean,
      default: false
    },
    toggleClass: {
      type: String,
      default: ''
    }
    // скрытие элементов, выходящих за рамки toggle элемента
    // isToggleOverflowAllowed: {
    //   type: B
    // }
  },
  data() {
    return {
      isOpen: false,
      isHidedToggle: false
    };
  },
  mounted() {
    this.isOpen = this.defaultOpen;
  },
  methods: {
    click() {
      this.isOpen = !this.isOpen;
      if (this.isHidedToggleAfterOpening) {
        this.isHidedToggle = true;
      }
    },
    closeCollapse() {
      this.isOpen = false;
      if (this.isHidedToggleAfterOpening) {
        this.isHidedToggle = false;
      }
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-collapse';

#{$this} {
  #{$this}__toggle {
    cursor: pointer;
    display: grid;
    grid-template-rows: 1fr;
    transition: grid-template-rows 280ms cubic-bezier(0.4, 0, 0.5, 1);
    will-change: grid-template-rows;

    & > * {
      overflow: hidden;
    }

    &.--hide {
      grid-template-rows: 0fr;
    }
  }
  #{$this}__collapse {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 300ms cubic-bezier(0, 0, 0.3, 1);
    will-change: grid-template-rows;

    & > * {
      overflow: hidden;
    }

    &.--show > * {
      overflow: visible; 
    }

    &.--show {
      grid-template-rows: 1fr;
      transition: grid-template-rows 300ms cubic-bezier(0, 0, 0.3, 1);
    }
  }
}

.security-info {
  #{$this} {
    #{$this}__collapse {
      &.--show > * {
        overflow: auto !important;  // стиль для .security-info при наличии .--show
      }
    }
  }
}
</style>
